import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input, message } from 'antd';
import { CompanySelectBox } from 'components/atoms'
import { fetcher } from 'services';

export interface CompanyMatchModalProps extends PopupProps {
    company: string;
}

const CompanyMatchModal = ({ isOpen, onClose, company }: CompanyMatchModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
  const [companySrl, setCompanySrl] = useState<number>(0);
  const [companyName, setCompanyName] = useState<string>(''); 

  /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();

   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };
        
    const onSubmit = (e) => {
        fetcher.company.postCompanyMatchAdd({
            id: companySrl,
            name: company,
        })
        .then((res) => {
            switch (res.code) {
                case 200:
                    message.info('매칭 정보가 등록 되었습니다.', 1);
                    onClose?.(true, companySrl, companyName);
                break;
                default:  
                    message.error('등록중 오류 발생하였습니다.', 1);
                    onClose?.(false);
                break;
            };
        });         
};
  
  /* ======================================================
   * effects
   * ====================================================== */

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={460} title={'고객사 매칭 정보 등록'} closable>
            <Form
                form={form}
                name="RefCode"
                layout="horizontal"  
                labelCol={{ flex: '125px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item label={'고객사명'}>
                    <label>{company}</label>
                </Form.Item>    
                <Form.Item name="company_srl" label={'기존 고객사'} rules={[{ required: true, message: '' }]}>
                    <CompanySelectBox required={true} form={form} company_srl={companySrl} onSelected={(value, option) => {setCompanySrl(Number(value)); setCompanyName(option.label);}} />
                </Form.Item>                    
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCancel}>취소</Button>
                    <Button htmlType="submit"  type="primary" disabled={!companySrl}>등록</Button>
                </ButtonGroup>                
            </Form>
        </ModalWrapper>  
    )    
};

export default React.memo(CompanyMatchModal);    